export const gridPreferencePanelStateSelector = state => state.preferencePanel;


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/preferencesPanel/gridPreferencePanelSelector.js
// module id = 206
// module chunks = 25